<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('embroidery orders')"
      :columns="columns"
      :column_search="true"
      resource_url="/embroidery-order/datatables"
    >
      <template v-slot:buttons>
        <button class="button is-secondary is-rounded" @click="create">
          <span class="icon"><i class="fa fa-plus"></i></span>
          <span>{{ $t("add") }}</span>
        </button>
      </template>
    </generic-table>
    <order-modal ref="order_modal" @success="refresh" />
    <order-details-modal ref="order_details_modal" />
  </div>
</template>

<script>
import GenericTable from "@/components/generic_table/GenericTable.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  error_message,
  format_currency,
  format_date,
} from "@/utils";
import OrderModal from "../order_modal/Index.vue";
import OrderDetailsModal from "../order_details_modal/Index.vue";

export default {
  name: "ProvidersDatatable",
  components: { GenericTable, OrderModal, OrderDetailsModal },
  data() {
    let v = this;
    return {
      columns: [
        {
          title: v.$t("status"),
          searchable: false,
          // width: "15%",
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return `<div class="content subtitle is-5 mb-1 has-text-primary">
                      ${v.translate_status(row.status_code)}
                    </div>
                    <div class="content subtitle is-6 mb-1">
                      <span class="icon has-text-success">
                        <i class="fa fa-calendar"></i>
                      </span>
                      ${format_date(row.settings.received_date)}
                    </div>
                    <div class="content subtitle is-6">
                      <span class="icon has-text-warning">
                        <i class="fa fa-calendar"></i>
                      </span>
                      ${format_date(row.settings.delivery_date)}
                    </div>`;
          },
        },
        {
          title: v.$t("customer"),
          searchable: false,
          // width: "25%",
          data: (row) => {
            return `<div class="media-content">
                <div class="title is-5">
                  <span>${row.customer.name}</span>
                </div>
                <div class="subtitle is-6 mb-0" >
                  <span class="icon">
                    <i class="fa fa-at"></i>
                  </span>
                  ${row.customer.email}
                </div>
                <div
                  class="subtitle is-6 mb-0"
                >
                  <span class="icon">
                    <i class="fa fa-phone"></i>
                  </span>
                  ${row.customer.phone}
                </div>
              </div>`;
          },
        },
        {
          title: v.$t("order"),
          searchable: false,
          // width: "15%",
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            let items = row.embroidery_order_items.map((item) => {
              return `<li>${item.quantity} x ${item.embroidery.name}</li>`;
            });
            return `<div class="content subtitle is-6"><ul class="mt-0">${items.join(
              ""
            )}</ul></div>`;
          },
        },
        {
          title: v.$t("total"),
          searchable: false,
          // width: "15%",
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return format_currency(row.total || 0);
          },
        },
        {
          title: v.$t("options"),
          searchable: false,
          data: (row) => {
            return generate_datatables_buttons([
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("edit"),
                icon: "fa fa-edit",
                icon_class: "is-small",
                click: function (e) {
                  // console.log("edit order", e.detail.uuid);
                  v.$refs.order_modal.edit_modal(row);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("details"),
                icon: "fa fa-eye",
                icon_class: "is-small",
                click: function (e) {
                  // console.log("edit order", e.detail.uuid);
                  v.$refs.order_details_modal.show_modal(row.uuid);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  confirm_deletion_dialog(
                    v.$t("are you sure to delete order?"),
                    v,
                    () => {
                      del("/embroidery-order", { uuid: uuid })
                        .then(() => {
                          v.refresh();
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    }
                  );
                },
              },
            ]);
          },
        },
      ],
    };
  },
  methods: {
    format_date,
    format_currency,
    create() {
      let v = this;
      v.$refs.order_modal.show_modal();
    },
    refresh() {
      let v = this;
      v.$refs.datatable.refresh();
    },
    translate_status(status_code) {
      let v = this;
      switch (status_code) {
        case "N":
          return v.$t("new");
        case "D":
          return v.$t("discarded");
        case "L":
          return v.$t("delivered");
        case "F":
          return v.$t("finished");
        case "B":
          return v.$t("buying materials");
        case "P":
          return v.$t("in production");
        default:
          return status_code;
      }
    },
  },
  mounted() {
    this.refresh();
  },
};
</script>

<style></style>
